import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

export function Field2({ label, value, onChange, type = 'text', placeholder, testId }) {
    return (
        <div>
            <Label className="text-[12px] font-medium text-[color:var(--bm-text-muted)]">{label}</Label>
            <Input
                type={type}
                value={value ?? ''}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                className="mt-1.5 h-10"
                data-testid={testId}
            />
        </div>
    );
}
